import React from 'react';

interface TooltipProps {
  text: string;
  children: React.ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
}

const Tooltip: React.FC<TooltipProps> = ({ text, children, position = 'top', className = '' }) => {
  const getPositionClasses = () => {
    switch (position) {
      case 'bottom':
        return 'top-full mt-2';
      case 'left':
        return 'right-full mr-2';
      case 'right':
        return 'left-full ml-2';
      case 'top':
      default:
        return 'bottom-full mb-2';
    }
  };

  return (
    <div className={`relative group flex items-center justify-center ${className}`}>
      {children}
      <div
        className={`absolute ${getPositionClasses()} w-max whitespace-nowrap bg-slate-800 dark:bg-black text-white text-xs font-semibold rounded-md py-1 px-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none z-50 transform`}
        role="tooltip"
      >
        {text}
      </div>
    </div>
  );
};

export default Tooltip;